import Section from "@/components/ui/section";
import Image from "next/image";
import React from "react";

export default function WhereWeWork() {
  return (
    <Section id="where-we-work" className={"!pt-12 !pb-0"}>
      <h2 className="text-darkBlue text-center w-fit mx-auto border-b-[2px] border-blue mb-6">
        Where we work
      </h2>
      <Image
        src={"/images/world-map.webp"}
        alt={"world map"}
        className="object-cover object-center"
        width={1920}
        height={1080}
      />
    </Section>
  );
}
